import React from 'react';

import { Icon } from '@chakra-ui/react';

export const AIPipelineIcon = props => (
  <Icon viewBox="0 0 721 720" w="full" h="full" color="inherit" {...props}>
    <g transform="translate(-280 0)">
      <g>
        <g>
          <g>
            <g>
              <path
                d="M1061.05 470.393C1053.68 461.541 1040.91 459.498 1031.14 465.607L821.717 619.38 821.717 625.961C833.532 624.561 844.242 633.004 845.642 644.818 847.042 656.632 838.6 667.342 826.785 668.742 825.101 668.943 823.402 668.943 821.717 668.742 826.576 668.763 831.306 667.187 835.18 664.255L1056.86 500.609C1065.81 493.106 1067.62 480.048 1061.05 470.393Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00278 0 0 1 -183 -53.8504)"
              />
              <path
                d="M821.717 668.742C809.903 667.342 801.461 656.632 802.861 644.818 804.034 634.93 811.83 627.134 821.717 625.961L821.717 625.961 821.717 619.38 612.299 465.607C602.561 459.357 589.684 461.418 582.382 470.393 575.835 480.065 577.931 493.163 587.169 500.31L808.853 663.956C812.635 666.846 817.257 668.422 822.017 668.443Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00278 0 0 1 -183 -53.8504)"
              />
              <path
                d="M821.717 603.524C797.428 603.524 777.74 623.212 777.74 647.501 777.74 671.791 797.428 691.479 821.717 691.479 846.007 691.479 865.695 671.791 865.695 647.501 865.695 623.212 846.007 603.524 821.717 603.524ZM821.717 668.742C809.823 668.742 800.177 659.097 800.18 647.199 800.18 635.304 809.826 625.662 821.72 625.662 833.618 625.662 843.261 635.307 843.261 647.205 843.261 647.304 843.258 647.403 843.258 647.501 843.258 659.232 833.75 668.742 822.02 668.745 821.918 668.745 821.819 668.742 821.717 668.742Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00278 0 0 1 -183 -53.8504)"
              />
              <path
                d="M642.216 237.64C629.891 237.478 619.94 227.527 619.778 215.202L619.778 158.958C618.34 146.484 627.288 135.205 639.762 133.767 652.236 132.329 663.515 141.277 664.953 153.751 665.152 155.481 665.152 157.228 664.953 158.958L664.953 215.202C664.789 227.643 654.658 237.641 642.216 237.64Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00278 0 0 1 -183 -53.8504)"
              />
              <path
                d="M664.355 413.85C664.355 426.408 654.175 436.587 641.618 436.587 629.061 436.587 618.881 426.408 618.881 413.85 618.881 401.293 629.061 391.114 641.618 391.114 654.175 391.114 664.355 401.293 664.355 413.85Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00278 0 0 1 -183 -53.8504)"
              />
              <path
                d="M664.355 347.734C664.355 360.291 654.175 370.471 641.618 370.471 629.061 370.471 618.881 360.291 618.881 347.734 618.881 335.177 629.061 324.997 641.618 324.997 654.175 324.997 664.355 335.177 664.355 347.734Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00278 0 0 1 -183 -53.8504)"
              />
              <path
                d="M664.355 281.319C664.355 293.876 654.175 304.055 641.618 304.055 629.061 304.055 618.881 293.876 618.881 281.319 618.881 268.761 629.061 258.582 641.618 258.582 654.175 258.582 664.355 268.761 664.355 281.319Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00278 0 0 1 -183 -53.8504)"
              />
              <path
                d="M1001.22 303.457C988.779 303.294 978.781 293.162 978.781 280.72L978.781 224.476C978.781 212.085 988.827 202.039 1001.22 202.039 1013.61 202.039 1023.66 212.085 1023.66 224.476L1023.66 280.72C1023.83 293.111 1013.91 303.29 1001.52 303.455 1001.42 303.456 1001.32 303.457 1001.22 303.457Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00278 0 0 1 -183 -53.8504)"
              />
              <path
                d="M1024.55 414.15C1024.55 426.707 1014.37 436.886 1001.82 436.886 989.26 436.886 979.08 426.707 979.08 414.15 979.08 401.592 989.26 391.413 1001.82 391.413 1014.37 391.413 1024.55 401.592 1024.55 414.15Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00278 0 0 1 -183 -53.8504)"
              />
              <path
                d="M1024.55 346.837C1024.55 359.394 1014.37 369.573 1001.82 369.573 989.26 369.573 979.08 359.394 979.08 346.837 979.08 334.279 989.26 324.1 1001.82 324.1 1014.37 324.1 1024.55 334.279 1024.55 346.837Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00278 0 0 1 -183 -53.8504)"
              />
              <path
                d="M1024.55 158.958C1024.55 171.516 1014.37 181.695 1001.82 181.695 989.26 181.695 979.08 171.516 979.08 158.958 979.08 146.401 989.26 136.222 1001.82 136.222 1014.37 136.222 1024.55 146.401 1024.55 158.958Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00278 0 0 1 -183 -53.8504)"
              />
              <path
                d="M821.717 503.601C809.392 503.44 799.441 493.489 799.28 481.163L799.28 424.022C800.719 411.547 811.997 402.602 824.47 404.038 834.965 405.249 843.246 413.527 844.454 424.022L844.454 480.565C844.619 493.121 834.576 503.434 822.02 503.598 821.918 503.601 821.819 503.601 821.717 503.601Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00278 0 0 1 -183 -53.8504)"
              />
              <path
                d="M844.454 546.981C844.454 559.538 834.275 569.717 821.717 569.717 809.16 569.717 798.981 559.538 798.981 546.981 798.981 534.424 809.16 524.244 821.717 524.244 834.275 524.244 844.454 534.424 844.454 546.981Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00278 0 0 1 -183 -53.8504)"
              />
              <path
                d="M844.454 358.205C844.454 370.762 834.275 380.942 821.717 380.942 809.16 380.942 798.981 370.762 798.981 358.205 798.981 345.648 809.16 335.468 821.717 335.468 834.275 335.468 844.454 345.648 844.454 358.205Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00278 0 0 1 -183 -53.8504)"
              />
              <path
                d="M844.454 291.789C844.454 304.347 834.275 314.526 821.717 314.526 809.16 314.526 798.981 304.347 798.981 291.789 798.981 279.232 809.16 269.053 821.717 269.053 834.275 269.053 844.454 279.232 844.454 291.789Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00278 0 0 1 -183 -53.8504)"
              />
              <path
                d="M911.468 370.172C899.142 370.01 889.192 360.06 889.03 347.734L889.03 291.49C887.591 279.016 896.54 267.737 909.015 266.299 921.487 264.861 932.766 273.808 934.205 286.283 934.405 288.013 934.405 289.76 934.205 291.49L934.205 347.734C934.04 360.174 923.911 370.172 911.468 370.172Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00278 0 0 1 -183 -53.8504)"
              />
              <path
                d="M934.504 225.075C934.504 237.632 924.324 247.812 911.767 247.812 899.21 247.812 889.03 237.632 889.03 225.075 889.03 212.518 899.21 202.338 911.767 202.338 924.324 202.338 934.504 212.518 934.504 225.075Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00278 0 0 1 -183 -53.8504)"
              />
              <path
                d="M934.504 479.368C934.504 491.926 924.324 502.105 911.767 502.105 899.21 502.105 889.03 491.926 889.03 479.368 889.03 466.811 899.21 456.632 911.767 456.632 924.324 456.632 934.504 466.811 934.504 479.368Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00278 0 0 1 -183 -53.8504)"
              />
              <path
                d="M934.504 412.953C934.504 425.51 924.324 435.69 911.767 435.69 899.21 435.69 889.03 425.51 889.03 412.953 889.03 400.396 899.21 390.216 911.767 390.216 924.324 390.216 934.504 400.396 934.504 412.953Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00278 0 0 1 -183 -53.8504)"
              />
              <path
                d="M754.404 479.368C754.404 491.926 744.225 502.105 731.668 502.105 719.11 502.105 708.931 491.926 708.931 479.368 708.931 466.811 719.11 456.632 731.668 456.632 744.225 456.632 754.404 466.811 754.404 479.368Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00278 0 0 1 -183 -53.8504)"
              />
              <path
                d="M754.404 291.789C754.404 304.347 744.225 314.526 731.668 314.526 719.11 314.526 708.931 304.347 708.931 291.789 708.931 279.232 719.11 269.053 731.668 269.053 744.225 269.053 754.404 279.232 754.404 291.789Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00278 0 0 1 -183 -53.8504)"
              />
              <path
                d="M754.404 225.075C754.404 237.632 744.225 247.812 731.668 247.812 719.11 247.812 708.931 237.632 708.931 225.075 708.931 212.518 719.11 202.338 731.668 202.338 744.225 202.338 754.404 212.518 754.404 225.075Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00278 0 0 1 -183 -53.8504)"
              />
              <path
                d="M731.967 435.69C719.752 435.699 709.713 426.057 709.23 413.85L709.23 357.008C709.23 344.617 719.276 334.571 731.668 334.571 744.059 334.571 754.105 344.617 754.105 357.008L754.105 413.85C753.785 425.892 744.012 435.534 731.967 435.69Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00278 0 0 1 -183 -53.8504)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
);
